var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteConfirmationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 250C0 111.914 111.914 0 250 0C388.086 0 500 111.914 500 250C500 388.086 388.086 500 250 500C111.914 500 0 388.086 0 250ZM363.086 206.836C373.73 196.191 373.73 178.809 363.086 168.164C352.441 157.52 335.059 157.52 324.414 168.164L218.75 273.828L175.586 230.664C164.941 220.02 147.559 220.02 136.914 230.664C126.27 241.309 126.27 258.691 136.914 269.336L199.414 331.836C210.059 342.48 227.441 342.48 238.086 331.836L363.086 206.836Z",
    fill: "#008393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteConfirmationIcon);
export default __webpack_public_path__ + "static/media/complete-confirmation-icon.7013c761a157dc5d06326ea3bdcaedef.svg";
export { ForwardRef as ReactComponent };